import React from 'react';

const Placeholder = () => (
  <div className='drag-placeholder text-center'>
    There is no record to show
  </div>
);

export default Placeholder;